import { useState } from 'react';
import { api, sessao } from '../api';

export default function Login() {
  const [f, setF] = useState({ login: '', senha: '', empresa: '' });
  const [pedirEmpresa, setPedirEmpresa] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const entrar = async e => {
    e.preventDefault();
    setErro(''); setCarregando(true);
    try {
      const body = { login: f.login, senha: f.senha };
      if (pedirEmpresa && f.empresa) body.empresa = f.empresa;
      const r = await api('/auth/login', { method: 'POST', body });
      sessao.entrar(r.token, r.usuario);
      window.location.href = '/';
    } catch (err) {
      if (err.message.includes('mais de uma empresa')) {
        setPedirEmpresa(true);
        setErro('Esse login existe em mais de uma empresa. Informe qual.');
      } else {
        setErro(err.message);
      }
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--verde-esc)' }}>
      <form onSubmit={entrar} className="card" style={{ width: 360, padding: 26 }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img src="/logo.png" alt="" style={{ width: 60, marginBottom: 6 }} />
          <div style={{ fontWeight: 900, fontSize: 24 }}>LAB<span style={{ color: 'var(--verde)' }}> Morais</span></div>
          <div style={{ fontSize: 12.5, color: 'var(--cinza)' }}>Sistema de Ordens de Serviço</div>
        </div>
        {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
        <div style={{ display: 'grid', gap: 12 }}>
          <div>
            <label className="label">Login</label>
            <input className="input" value={f.login} autoFocus
              onChange={e => setF({ ...f, login: e.target.value })} />
          </div>
          <div>
            <label className="label">Senha</label>
            <input className="input" type="password" value={f.senha}
              onChange={e => setF({ ...f, senha: e.target.value })} />
          </div>
          {pedirEmpresa && (
            <div>
              <label className="label">Empresa</label>
              <input className="input" value={f.empresa}
                onChange={e => setF({ ...f, empresa: e.target.value })} />
            </div>
          )}
          <button className="btn" disabled={carregando}>{carregando ? 'Entrando…' : 'Entrar'}</button>
        </div>
      </form>
    </div>
  );
}
